import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { langSelector } from '../../../../../store/langSlice';
import { getLang } from '../../../../../environnement';

function TimerItem({
  isPrimary=false,
  details,
  value,
  label,
  lang
}) {
  return (
    <div className='flex flex-col items-center'>
      <div className={`rounded-[20px] w-14 h-14 ${details ? 'sm:w-20 sm:h-20' : 'xxs:w-20 xxs:h-20'} flex justify-center items-center ${isPrimary ? 'bg-primary' : 'bg-white'}`}>
        <p className={`${isPrimary ? 'text-white' : 'text-primary'} ${details ? 'text-sm sm:text-3xl' : 'text-xl xxs:text-3xl'} font-semiBold`} style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{value}</p>
      </div>
      <p className={`${isPrimary ? 'text-primary' : 'text-white'} ${details ? 'text-sm sm:text-3xl' : 'text-xl xxs:text-3xl'} font-semiBold`} style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{label}</p>
    </div>
  );
}

export default function TimerEvent({
  primary=false,
  details=false,
  targetDate
}) {
  const parseTargetDate = () => {
    const [day, month, year] = targetDate.split("-").map(Number);
    return new Date(year, month - 1, day, 8, 0, 0);
  };

  const calculateTimeLeft = () => {
    const now = new Date();
    const difference = parseTargetDate() - now;

    if (difference <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / (1000 * 60)) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  const lang = useSelector(langSelector);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);
  return (
    <div className='flex justify-center items-center my-10' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none'}}>
      <div className='px-5 xxs:px-0 flex justify-between items-center w-[300px] sm:w-[450px]'>
        <TimerItem details={details} isPrimary={primary} lang={lang} value={timeLeft.days} label={getLang(lang).firstWorldCup.jour} />
        <TimerItem details={details} isPrimary={primary} lang={lang} value={timeLeft.hours} label={getLang(lang).firstWorldCup.heure} />
        <TimerItem details={details} isPrimary={primary} lang={lang} value={timeLeft.minutes} label={getLang(lang).firstWorldCup.minute} />
        <TimerItem details={details} isPrimary={primary} lang={lang} value={timeLeft.seconds} label={getLang(lang).firstWorldCup.seconde} />
      </div>
    </div>
  );
}
